class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.generateRecommendations();
  }

  generateRecommendations() {   
    fetch(`${window.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${this.dataset.productId}&limit=${this.dataset.limit}`)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        const cart_drawer = document.querySelector('cart-drawer');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.removeAttribute('style');
          if (cart_drawer) cart_drawer.classList.remove('no-recommendations');
        } else {
          this.style.display = 'none';
          if (cart_drawer) cart_drawer.classList.add('no-recommendations');
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);